// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jieNh","title":"styles_title__svzah","subtitle":"styles_subtitle__VWp3v","paragraph":"styles_paragraph__x+rJi","uls":"styles_uls__P001-"};